import React from "react";
import * as FA from "react-icons/fa";
import { Link } from "react-router-dom";
import { AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";

export function AdminNavHome() {
  // Parse the menu data from localStorage
  const menuData = JSON.parse(localStorage.getItem("userMENUS")) || []; // Default to an empty array if null

  return (
    <div>
      {menuData.length > 0 ? (
        menuData.map((menu, index) => {
          // Dynamically retrieve the icon component
          const IconComponent = FA[menu.iconCode];

          return (
            <AccordionItem key={menu.menuId} value={`item-${index + 1}`}>
              <AccordionTrigger>
                <div className="flex items-center gap-3 font-nunito w-full">
                  {/* Render the icon if it exists */}
                  {IconComponent && (
                    <IconComponent className="text-[#464F66] w-[16px] h-[16px] ml-[1px]" />
                  )}
                  <h2 className="text-[#464F66] text-[12px]">{menu.menuName}</h2>
                </div>
              </AccordionTrigger>
              <AccordionContent>
                {menu.submenus && (
                  <ul className="w-[75%] mx-auto text-start pl-3 mt-1">
                    {menu.submenus.map((submenu) => (
                      <li
                        key={submenu.menuItemId}
                        className="hover:bg-gray-100 rounded-md text-[13px] p-1.5 px-3"
                      >
                        <Link to={submenu.actionUrl}>{submenu.menuItemName}</Link>
                      </li>
                    ))}
                  </ul>
                )}
              </AccordionContent>
            </AccordionItem>
          );
        })
      ) : (
        <p className="mt-3 mb-2 px-4 text-sm text-[#6E7891]">
          No Menu Available
        </p>
      )}
    </div>
  );
}
